import Image from "next/image"
import { cn } from "@/lib/utils"
import type { DomainKey } from "@/lib/domain"

// bg = tom exato do fundo do ficheiro de logo (aviadores.jpeg não tem
// transparência) — deve casar com a imagem, não com o token navy-900.
const LOGOS: Record<DomainKey, { src: string; bg: string }> = {
  aviadores: { src: "/aviadores.jpeg", bg: "#001540" },
  helicopteros: { src: "/logo-helicopteros.png", bg: "#001540" },
}

interface AeronaveNoPhotoProps {
  domainKey: DomainKey
  className?: string
}

// Server-safe: recebe domainKey por prop (sem useDomain) para poder ser
// renderizado dentro dos cards server-side do catálogo.
export function AeronaveNoPhoto({ domainKey, className }: AeronaveNoPhotoProps) {
  const logo = LOGOS[domainKey]

  return (
    <div
      className={cn("relative h-full w-full", className)}
      style={{ backgroundColor: logo.bg }}
    >
      <Image
        src={logo.src}
        alt=""
        fill
        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
        className="object-contain p-[12%]"
        aria-hidden="true"
      />
    </div>
  )
}
